import { ResourcePolicy } from '@/policies';
import { auth } from '@/services';

angular.module('app')
    .service('Resources', resources);

resources.$inject = [
    '$uibModal',
];

function resources(
    $uibModal,
) {
    /**
     * Shows a modal allowing an administrator to create or modify a resource
     *
     * @param  {(null | number)=} resourceId? - if provided, will manage this resource. Null for new.
     * @return {Promise<any>}
     */
    function manageResource(resourceId?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            if (!resourceId && !ResourcePolicy.canCreate(auth.user())) {
                return reject('Cannot create resource: permission denied.');
            }

            $uibModal.open({
                templateUrl: 'modals/manage-resource.html',
                controller: 'manageResourceController',
                controllerAs: 'vm',
                windowClass: 'manage-resource',
                resolve: {
                    resourceId: () => resourceId,
                },
            }).result
                .then(resolve)
                .catch(reject);
        });
    }

    return {
        manageResource,
    };
}
